export default "__VITE_ASSET__GT$hbeoV__"